import React from 'react';
import Table from 'react-bootstrap/Table';

const SplitsView = ({ 
  localData, 
  safeGame, 
  awayBatters, 
  homeBatters,
  splitsData, 
  formatStatValue,
  getTeamLogoUrl,
  getStatCellStyle,
  pitchesView = 'main'
}) => {
  // Helper function to render a split table
  const renderSplitTable = (pitcherTeam, splitType, batters, tableTitle) => {
    const pitcher = localData?.pitchers?.find(p => p.batterTeam === pitcherTeam && p.handType === splitType);
    const pitchTypes = pitcher?.pitchesForSplit || [];
    
    if (!pitcher || pitchTypes.length === 0) {
      return null;
    }
    
    return (
      <div className="table-container">
        <Table bordered size="sm" className="text-center">
          <thead>
            <tr>
              <th className="text-start" style={{ width: '200px', minWidth: '200px', maxWidth: '200px' }}></th>
              {pitchTypes.slice(0, 4).map((pitch, idx) => (
                <React.Fragment key={idx}>
                  <th colSpan={idx < 3 ? "4" : "3"}>{pitch.pitchType.replace('Fastball', 'FB')} ({pitch.usage}%)</th>
                </React.Fragment>
              ))}
            </tr>
            <tr>
              <th></th>
              {pitchTypes.slice(0, 4).map((pitch, idx) => (
                <React.Fragment key={idx}>
                  {pitchesView === 'main' ? (
                    <>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>AVG</th>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>SLG</th>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>HR</th>
                    </>
                  ) : (
                    <>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>HH%</th>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>Barrel%</th>
                      <th style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.7rem' }}>AvgXV</th>
                    </>
                  )}
                  {idx < 3 && <th style={{ width: '20px', backgroundColor: '#000', border: 'none' }}></th>}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr className="pitcher-row" style={{ backgroundColor: 'rgb(26,26,26)' }}>
              <td className="player-name-cell text-start" style={{ 
                backgroundImage: `url(${getTeamLogoUrl(pitcherTeam)})`,
                backgroundColor: 'rgb(26,26,26)',
                color: 'white'
              }}>
                <span>{pitcher.playerName}</span>
              </td>
              {pitchTypes.slice(0, 4).map((pitch, idx) => (
                <React.Fragment key={idx}>
                  {pitchesView === 'main' ? (
                    <>
                      <td style={{
                        ...getStatCellStyle(`pitch${idx+1}_avg`, pitcher[`pitch${idx+1}_avg`]),
                        ...(getStatCellStyle(`pitch${idx+1}_avg`, pitcher[`pitch${idx+1}_avg`]).backgroundColor ? {} : { backgroundColor: 'rgb(26,26,26)', color: 'white' })
                      }}
                      title={pitcher[`pitch${idx+1}_ab`] > 0 ? `${pitcher[`pitch${idx+1}_ab`]} AB` : (pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined)}>{formatStatValue(pitcher[`pitch${idx+1}_avg`], 'decimal', { atBats: pitcher[`pitch${idx+1}_ab`] || pitch.atBats || 0 })}</td>
                      <td style={{
                        ...getStatCellStyle(`pitch${idx+1}_slg`, pitcher[`pitch${idx+1}_slg`]),
                        ...(getStatCellStyle(`pitch${idx+1}_slg`, pitcher[`pitch${idx+1}_slg`]).backgroundColor ? {} : { backgroundColor: 'rgb(26,26,26)', color: 'white' })
                      }}
                      title={pitcher[`pitch${idx+1}_ab`] > 0 ? `${pitcher[`pitch${idx+1}_ab`]} AB` : (pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined)}>{formatStatValue(pitcher[`pitch${idx+1}_slg`], 'decimal', { atBats: pitcher[`pitch${idx+1}_ab`] || pitch.atBats || 0 })}</td>
                      <td style={{ backgroundColor: 'rgb(26,26,26)', color: 'white', width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.9rem' }}
                      title={pitcher[`pitch${idx+1}_ab`] > 0 ? `${pitcher[`pitch${idx+1}_ab`]} AB` : (pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined)}>{pitcher[`pitch${idx+1}_hr`] || 0}</td>
                    </>
                  ) : (
                    <>
                      <td style={{
                        ...getStatCellStyle(`pitch${idx+1}_hhPercent`, pitch.hardHitRate || 0),
                        ...(getStatCellStyle(`pitch${idx+1}_hhPercent`, pitch.hardHitRate || 0).backgroundColor ? {} : { backgroundColor: 'rgb(26,26,26)', color: 'white' })
                      }}
                      title={pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined}>{formatStatValue(pitch.hardHitRate || 0, 'percentage')}</td>
                      <td style={{
                        ...getStatCellStyle(`pitch${idx+1}_barrelPercent`, pitch.barrelRate || 0),
                        ...(getStatCellStyle(`pitch${idx+1}_barrelPercent`, pitch.barrelRate || 0).backgroundColor ? {} : { backgroundColor: 'rgb(26,26,26)', color: 'white' })
                      }}
                      title={pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined}>{formatStatValue(pitch.barrelRate || 0, 'percentage')}</td>
                      <td style={{ backgroundColor: 'rgb(26,26,26)', color: 'white', width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.9rem' }}
                      title={pitch.atBats > 0 ? `${pitch.atBats} AB` : undefined}>{formatStatValue(pitch.avgExitVelo || 0, 'velocity')}</td>
                    </>
                  )}
                  {idx < 3 && <td style={{ width: '20px', backgroundColor: '#000', border: 'none' }}></td>}
                </React.Fragment>
              ))}
            </tr>
            
            {/* Buffer row between pitcher and batters */}
            <tr style={{ height: '5px', backgroundColor: '#000' }}>
              <td colSpan={1 + (pitchTypes.slice(0, 4).length * 3) + (pitchTypes.slice(0, 4).length - 1)} style={{ backgroundColor: '#000', padding: '0', height: '5px' }}></td>
            </tr>
            
            {batters.map((batter, index) => (
              <tr key={index}>
                <td className="player-name-cell text-start" style={{ 
                  backgroundImage: `url(${getTeamLogoUrl(batter.batterTeam)})`
                }}>
                  <span>{batter.batterName}</span>
                  <span style={{ fontSize: '0.75rem', color: '#6c757d', marginLeft: '8px' }}>
                    {(() => {
                      const batterHand = batter.batterBats || batter.battingHand;
                      const bHand = batterHand === 'Left' || batterHand === 'L' ? 'L' : batterHand === 'Right' || batterHand === 'R' ? 'R' : (batterHand || '?');
                      
                      // Get pitcher hand from splits data or raw data
                      let pHand = '?';
                      if (batter.pitcherHandFacing) {
                        // Use the hand from splits data (vsLHP -> L, vsRHP -> R)
                        pHand = batter.pitcherHandFacing === 'vsLHP' ? 'L' : batter.pitcherHandFacing === 'vsRHP' ? 'R' : '?';
                      } else {
                        // Fallback to raw pitcher data
                        const rawPitcher = localData?.rawPitchersData?.find(p => p.pitcherTeam === pitcherTeam);
                        const pitcherThrows = rawPitcher?.pitcherThrows;
                        pHand = pitcherThrows === 'Left' || pitcherThrows === 'L' ? 'L' : pitcherThrows === 'Right' || pitcherThrows === 'R' ? 'R' : (pitcherThrows || '?');
                      }
                      
                      return `${bHand} vs ${pHand}`;
                    })()}
                  </span>
                </td>
                {pitchTypes.slice(0, 4).map((pitch, idx) => {
                  // Use the splitStats if available (from our enhanced data structure)
                  // Otherwise fall back to looking it up from top4Pitches
                  let batterPitchData;
                  
                  
                  if (batter.splitStats) {
                    // Use the pre-processed split stats
                    batterPitchData = batter.splitStats.find(p => p.pitchType === pitch.pitchType) || {};
                  } else {
                    // Fallback to manual lookup
                    const handType = splitType === 'vsRHB' ? 'vsRHP' : 'vsLHP';
                    batterPitchData = batter.top4Pitches?.[handType]?.find(p => p.pitchType === pitch.pitchType) || {};
                  }
                  
                  const avg = batterPitchData.battingAvg || 0;
                  const slg = batterPitchData.sluggingPct || 0;
                  const hr = batterPitchData.homeRuns || 0;
                  const hardHitRate = batterPitchData.hardHitRate || 0;
                  const barrelRate = batterPitchData.barrelRate || 0;
                  const avgExitVelo = batterPitchData.avgExitVelo || 0;
                  const atBats = batterPitchData.atBats || 0;
                  
                  
                  return (
                    <React.Fragment key={idx}>
                      {pitchesView === 'main' ? (
                        <>
                          <td style={getStatCellStyle(`pitch${idx+1}_avg`, avg)} title={atBats > 0 ? `${atBats} AB` : undefined}>{formatStatValue(avg, 'decimal', { atBats })}</td>
                          <td style={getStatCellStyle(`pitch${idx+1}_slg`, slg)} title={atBats > 0 ? `${atBats} AB` : undefined}>{formatStatValue(slg, 'decimal', { atBats })}</td>
                          <td style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.9rem' }} title={atBats > 0 ? `${atBats} AB` : undefined}>{hr || 0}</td>
                        </>
                      ) : (
                        <>
                          <td style={getStatCellStyle(`pitch${idx+1}_hhPercent`, hardHitRate)} title={atBats > 0 ? `${atBats} AB` : undefined}>{formatStatValue(hardHitRate, 'percentage')}</td>
                          <td style={getStatCellStyle(`pitch${idx+1}_barrelPercent`, barrelRate)} title={atBats > 0 ? `${atBats} AB` : undefined}>{formatStatValue(barrelRate, 'percentage')}</td>
                          <td style={{ width: '70px', minWidth: '70px', maxWidth: '70px', fontSize: '0.9rem' }} title={atBats > 0 ? `${atBats} AB` : undefined}>{formatStatValue(avgExitVelo, 'velocity')}</td>
                        </>
                      )}
                      {idx < 3 && <td style={{ width: '20px', backgroundColor: '#000', border: 'none' }}></td>}
                    </React.Fragment>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  // Use the splits data if available, otherwise fall back to regular batters
  const awayBattersToUse = splitsData?.awayBattersWithSplits || awayBatters;
  const homeBattersToUse = splitsData?.homeBattersWithSplits || homeBatters;
  
  return (
    <div className="d-flex flex-column" style={{ gap: '20px' }}>
      {/* Home Pitcher vs RHB with Away RH Batters */}
      {renderSplitTable(
        safeGame.home,
        'vsRHB',
        awayBattersToUse.filter(b => !b.isPitcher && !b.isBuffer && (b.battingHand === 'Right' || b.batterBats === 'Right')),
        `${safeGame.home} Pitcher vs RHB`
      )}

      {/* Home Pitcher vs LHB with Away LH Batters */}
      {renderSplitTable(
        safeGame.home,
        'vsLHB',
        awayBattersToUse.filter(b => !b.isPitcher && !b.isBuffer && (b.battingHand === 'Left' || b.batterBats === 'Left')),
        `${safeGame.home} Pitcher vs LHB`
      )}

      {/* Away Pitcher vs RHB with Home RH Batters */}
      {renderSplitTable(
        safeGame.away,
        'vsRHB',
        homeBattersToUse.filter(b => !b.isPitcher && !b.isBuffer && (b.battingHand === 'Right' || b.batterBats === 'Right')),
        `${safeGame.away} Pitcher vs RHB`
      )}

      {/* Away Pitcher vs LHB with Home LH Batters */}
      {renderSplitTable(
        safeGame.away,
        'vsLHB',
        homeBattersToUse.filter(b => !b.isPitcher && !b.isBuffer && (b.battingHand === 'Left' || b.batterBats === 'Left')),
        `${safeGame.away} Pitcher vs LHB`
      )}
    </div>
  );
};

export default SplitsView;